module.exports = __webpack_public_path__ + "img/Osmium.a46f3bd9.jpg";